<!-- cv简历信息表-左侧菜单 -->
<template>
  <div class='cv-menu-container'>
    <ul v-if='lang'>
      <li v-for='(item, index) in menuList'
          :key="item.id"
          :class="[(item.id === activeName) ? 'active' : '']"
          @click="goInfo(item)">{{index + 1}}.&nbsp;{{item.name[lang]}}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    lang: {
      type: String,
      default: ''
    }
  },
  components: {},
  data () {
    return {
      menuList: [
        {
          id: 'base',
          name: {
            en: 'Personal Information',
            cn: '基本信息'
          },
          pathName: {
            en: '/undergraduate/cv/en/base',
            cn: '/undergraduate/cv/cn/base'
          }
        },
        {
          id: 'family',
          name: {
            en: 'Family',
            cn: '家庭信息'
          },
          pathName: {
            en: '/undergraduate/cv/en/family',
            cn: '/undergraduate/cv/cn/family'
          }
        },
        {
          id: 'education',
          name: {
            en: 'Education Background',
            cn: '教育背景'
          },
          pathName: {
            en: '/undergraduate/cv/en/education',
            cn: '/undergraduate/cv/cn/education'
          }
        },
        {
          id: 'course',
          name: {
            en: 'Course Information',
            cn: '课程信息'
          },
          pathName: {
            en: '/undergraduate/cv/en/course',
            cn: '/undergraduate/cv/cn/course'
          }
        },
        {
          id: 'score',
          name: {
            en: 'Testing',
            cn: '标准化考试成绩'
          },
          pathName: {
            en: '/undergraduate/cv/en/score',
            cn: '/undergraduate/cv/cn/score'
          }
        },
        {
          id: 'credit',
          name: {
            en: 'Credit Course Information',
            cn: '学分课程信息'
          },
          pathName: {
            en: '/undergraduate/cv/en/credit',
            cn: '/undergraduate/cv/cn/credit'
          }
        },
        {
          id: 'awards',
          name: {
            en: 'Honors and Awards',
            cn: '奖项'
          },
          pathName: {
            en: '/undergraduate/cv/en/awards',
            cn: '/undergraduate/cv/cn/awards'
          }
        },
        {
          id: 'activity',
          name: {
            en: 'Activities',
            cn: '活动'
          },
          pathName: {
            en: '/undergraduate/cv/en/activity',
            cn: '/undergraduate/cv/cn/activity'
          }
        },
        {
          id: 'hobby',
          name: {
            en: 'Interests,Talents&Skills',
            cn: '爱好与特长'
          },
          pathName: {
            en: '/undergraduate/cv/en/hobby',
            cn: '/undergraduate/cv/cn/hobby'
          }
        }
      ],
      // 当前菜单
      activeName: ''
    }
  },
  computed: {},
  mounted () {
    this.activeName = this.$route.meta.kind
  },
  methods: {
    // 切换菜单-查看简历信息
    goInfo (item) {
      this.activeName = item.id
      this.$router.push({
        path: item.pathName[this.lang]
      })
    }
  }
}
</script>
<style lang='less' scoped>
.cv-menu-container li {
  width: 200px;
  height: 40px;
  padding-left: 8px;
  padding-right: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #667483;
  letter-spacing: 0;
  line-height: 40px;
  &.active {
    background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
    border-radius: 8px;
    color: #fff;
  }
}
</style>
